export default __webpack_public_path__ + "static/media/img4.8e88d8d5.png";